module.exports = __webpack_public_path__ + "img/H5-2.b2ff31bd.png";